module.exports = __webpack_public_path__ + "static/img/04-gsys.db1007a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-shouye/04-gsys.jpg
// module id = JKqC
// module chunks = 1